export default __webpack_public_path__ + "static/media/success.483127d3.svg";